package org.lennycodes.gradematewebsite.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

@Page("grademate")
@Composable
fun GradeMatePage(){
    HomePage()
}